import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'

/**
 * Hook for removing a parameter from the query string and replacing the current history entry without reloading the page.
 */
export function useReplaceParam() {
  const navigate = useNavigate()

  const replaceHistoryWithoutParam = useCallback(
    (param: string) => {
      const urlObj = new URL(window.location.href)

      urlObj.searchParams.delete(param)

      const qs = urlObj.searchParams.toString()
      const queryString = qs ? `?${qs}` : ''

      navigate(`${urlObj.pathname}${queryString}${urlObj.hash}`, { replace: true })
    },
    [navigate],
  )

  return replaceHistoryWithoutParam
}
